import type { IFields } from '@core-web/lib';
import { getGenericDefaultData } from '../../mockData';

const genericDefaultData = getGenericDefaultData();

export const SchemaGenerator = (defaultValues: any): IFields => {
  return {
    staticMenu: {
      title: 'staticMenu',
      defaultValue: defaultValues ? defaultValues.staticMenu : genericDefaultData?.staticMenu,
      placeHolder: 'Select static menu',
      label: 'Static menu',
    },
    environment: {
      title: 'environment',
      defaultValue: defaultValues ? defaultValues.environment : genericDefaultData?.environment,
      placeHolder: 'Select environment',
      label: 'Environment',
    },
  };
};
